import { useForm } from "@mantine/form";
import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import useApi from "../../services/useApi";
import SimpleSearch from "./SimpleSearch";
import SearchResults from "./SearchResults";
import SearchWrapper from "./SearchWrapper";
import { SearchFilters } from "src/model/SearchFilters";
import {
  setFiles,
  setFolders,
  setIsFirstSearch,
  setLoading,
  setLocations,
} from "src/state/search/searchSlice";
import { FolderDto, SearchResultsDto } from "@braoshzmvavz/picnube-common";

export default function SearchView(props: {}) {
  const dispatch = useAppDispatch();
  const searchState = useAppSelector((state) => state.search);

  const { globalSearch, loading } = useApi();

  const onSearchSubmit = (searchFilters: SearchFilters) => {
    console.log("onSearchSubmit", searchFilters);

    dispatch(setLoading(true));

    globalSearch(searchFilters, searchState.filesPage).then(
      (results: SearchResultsDto) => {
        dispatch(setLoading(false));

        dispatch(setIsFirstSearch(false));
        dispatch(setFiles(results.files));
        dispatch(setFolders(results.folders));
        dispatch(setLocations(results.locations));
      }
    );
  };

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex flex-col h-full">
        <SearchWrapper onSubmit={onSearchSubmit} />
      </div>
      <div className="flex flex-col w-full h-full">
        <SearchResults />
      </div>
    </div>
  );
}
